var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{attrs:{"to":"/settings"}},[_c('div',{staticClass:"side-menu-icon"},[_c('fa-icon',{attrs:{"icon":['fal', 'ellipsis-h-alt']}})],1),_c('span',{staticClass:"side-menu-label"},[_vm._v("Outros recursos")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }